import { render, staticRenderFns } from "./ProductLogo.vue?vue&type=template&id=a0fef666&scoped=true&"
import script from "./ProductLogo.vue?vue&type=script&lang=js&"
export * from "./ProductLogo.vue?vue&type=script&lang=js&"
import style0 from "./ProductLogo.vue?vue&type=style&index=0&id=a0fef666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fef666",
  null
  
)

export default component.exports